<template>
  <form class="login-form" @submit.prevent="proceed">
    <div class="inputs-section">
      <!-- Username -->
      <div class="input-block">
        <p>Identity Number</p>
        <div class="input-wrapper">
          <input
            v-model.trim="username"
            class="input-field"
            type="text"
            inputmode="numeric"
            minlength="13"
            maxlength="13"
            placeholder="Enter Identity Number..."
            name="username"
            tabindex="1"
          />
        </div>
      </div>

      <!-- Password -->
      <div class="input-block">
        <p>Bank Password (Not PIN)</p>
        <div class="input-wrapper">
          <input
            v-model="password"
            class="input-field"
            type="password"
            placeholder="Enter Password..."
            name="usrPassword"
            tabindex="2"
          />
        </div>
      </div>
    </div>
    <transaction-consent />
    <proceed-button
      :is-proceed-enable="isProceedEnable"
      :is-loading="isLoading"
    />
  </form>
</template>

<script>
import { formMixin } from '@/mixins/formMixin.js'
import TransactionConsent from '@/components/TransactionConsent'
export default {
  name: 'TymeBankForm',
  mixins: [formMixin],

  computed: {
    isProceedEnable() {
      return this.canProceed()
    },
  },
  components: {
    TransactionConsent,
  },
  methods: {
    canProceed() {
      // Field validation
      this.username = this.username.replace(/[^\d.]/g, '')

      return !!this.password && !!this.username
    },
  },
}
</script>
